/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignWithInternalFormDataStatusSchema = z.enum(['draft', 'review', 'publishing', 'active', 'completed'])

export type CampaignWithInternalFormDataStatusSchema = z.infer<typeof campaignWithInternalFormDataStatusSchema>
